import { client } from "@/models/client";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { createTheme, Theme, ThemeProvider } from "@mui/material";

const onboardingTheme = (outer: Theme) =>
  createTheme(outer, {
    components: {
      MuiToggleButton: { defaultProps: { size: "medium" } },
      MuiToggleButtonGroup: { defaultProps: { size: "medium" } },
      MuiIconButton: { defaultProps: { size: "medium" } },
      MuiButton: { defaultProps: { size: "medium" } },
      MuiTextField: { defaultProps: { size: "medium" } },
      MuiFormControl: { defaultProps: { size: "medium" } },
      MuiAutocomplete: { defaultProps: { size: "medium" } },
      MuiCheckbox: { defaultProps: { size: "medium" } },
      MuiSwitch: { defaultProps: { size: "medium" } },
      MuiRadio: { defaultProps: { size: "medium" } },
    },
  });

export const Route = createFileRoute("/_auth/onboarding")({
  component: RouteComponent,
  beforeLoad: async ({ context, search, location }) => {
    if (!context.auth.isSignedIn) {
      throw redirect({ to: "/signup/$", search });
    }
    if (!context.auth.orgId && location.pathname !== "/onboarding/organization") {
      throw redirect({ to: "/onboarding/organization", search });
    }
    client.interceptors.request.use(async (config) => {
      const accessToken = await context.auth.getToken();
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      return config;
    });
  },
});

function RouteComponent() {
  return (
    <ThemeProvider theme={onboardingTheme}>
      <Outlet />
    </ThemeProvider>
  );
}
